@if (!firstItemLink()) {
    <h3 class="heading-2 text-primary text-center" i18n="@@our-capabilities-title">Our Capabilities</h3>
}
<in2-blog-list [blogList]="capabilitiesResource.value()" [class.first-item-link]="firstItemLink() !== null"></in2-blog-list>
